module.exports = __webpack_public_path__ + "static/media/32.9c0d14a6.png";